import { PROPERTY, IProperty, Property } from '@clooper/core';
import { Pipe, PipeTransform } from '@angular/core';
/**
  * PropertyNamePipe
  *
  * Pipe to construct the name of a Property
  */
@Pipe({ name: 'propertyName' })
export class PropertyNamePipe implements PipeTransform {

  /**
  * Constructs and returns name of a property.
  * @param {IProperty|Property} property A property Object.
  * @return {string} Returns property name.
  */
  transform(property: IProperty | Property): string {
    const occupancy = property.occupancy_type === PROPERTY.OCCUPANCY_TYPES.SHARED ? 'Shared' : '';
    return `${occupancy} ${property.total_rooms} bedroom ${property.property_type_name} at ${property.address.street} ${property.address.city}`;
  }
}
